
<template>
  <ResetPasswordComponent />
</template>

<script>
import ResetPasswordComponent from "@/components/auth/ResetPasswordComponent.vue";

export default {
  name: "ResetPasswordView",
  components: {
    ResetPasswordComponent,
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped>
</style>

